import { render } from "./topicBar.vue?vue&type=template&id=317c3978&scoped=true"
import script from "./topicBar.vue?vue&type=script&lang=js"
export * from "./topicBar.vue?vue&type=script&lang=js"

import "./topicBar.vue?vue&type=style&index=0&id=317c3978&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-317c3978"]])

export default __exports__